import ApiService from './ApiService'

const ROOT_URL = '/services/onboarding/api/task/private';

const TaskApi = new ApiService(ROOT_URL, '', {
  getMyActiveTask: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, '/getmyactivetask', data, onSuccess, onError)
  },
  getByProcessId: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, '/getactualbyprocessid', data, onSuccess, onError)
  },
  completeTask: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, '/completetask', data, onSuccess, onError)
  }
});

export default TaskApi;



// WEBPACK FOOTER //
// ./src/service/TaskService.js